document.addEventListener("DOMContentLoaded", function () {
  const triggers = document.querySelectorAll("[data-event='toggle-cart']");
  const addCartButtons = document.querySelectorAll("[data-event='add-to-cart']");
  const cartItemQuantity = document.querySelectorAll(
    ".Cart_Item .Quantity_Selector_Inputs input"
  );
  const cartItemRemove = document.querySelectorAll(
    "[data-event='remove-cart-item']"
  );

  function registerControls(quantity) {
    const key = quantity.closest(".Cart_Item").dataset.key;
    let previousValue = quantity.value;

    quantity.addEventListener("change", async function (e) {
      const value = quantity.value || 0;
      if (value == 0) quantity.closest(".Cart_Item").style.display = "none";
      if (!(await serverConfirmation(key, value))) {
        quantity.value = previousValue;
        if (value == 0) quantity.closest(".Cart_Item").style.display = "block";
        publish(PUB_SUB_EVENTS.cartUpdate, { source: this });
        publish(PUB_SUB_EVENTS.cartError, {
          source: this,
          message: `You've reached the maximum amount for this product variant`,
        });
        return;
      } else {
        previousValue = value;
        publish(PUB_SUB_EVENTS.cartUpdate, { source: this });
        return;
      }
    });
  }
  cartItemQuantity.forEach(registerControls);

  function registerRemove(remove) {
    const item = remove.closest(".Cart_Item");
    const key = item.dataset.key;
    remove.addEventListener("click", async function (e) {
      e.preventDefault();

      item.style.display = "none";
      if (!(await serverConfirmation(key, 0))) {
        item.style.display = "flex";
        publish(PUB_SUB_EVENTS.cartError, {
          source: this,
          message: "There was an error removing this item from your cart",
        });
        return;
      } else {
        publish(PUB_SUB_EVENTS.cartUpdate, { source: this });
      }
    });
  }
  cartItemRemove.forEach(registerRemove);

  function registerTrigger(trigger) {
    trigger.addEventListener("click", function (e) {
      e.preventDefault();
      publish(PUB_SUB_EVENTS.cartToggle, { source: this });
    });
  }

  triggers.forEach(registerTrigger);

  function registerAddCartButton(addCartButton) {
    addCartButton.addEventListener("click", function (e) {
      e.preventDefault();
      e.stopPropagation();

      const newsletter = document.querySelector(".Footer--newsletter form input[type='email']");

      window.scrollTo(
        0,
        newsletter.getBoundingClientRect().top + window.scrollY - 100
      );
      if (!newsletter.hasAttribute("tabindex")) {
        newsletter.setAttribute("tabindex", "-1");
      }
      newsletter.focus();
    });

    return;


    const form = addCartButton.closest("form");
    const variantId = form.querySelector("[name='id']").value;
    const quantityInput = form.querySelector("[name='quantity']");

    addCartButton.addEventListener("click", function (e) {
      e.preventDefault();
      e.stopPropagation();

      fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
        body: `id=${variantId}&quantity=${quantityInput.value}`,
      })
        .then((response) => response.json())
        .then((data) => {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: this, product: data });
          publish(PUB_SUB_EVENTS.cartToggle, { source: this });
        });
    });
  }

  addCartButtons.forEach(registerAddCartButton);

  subscribe(PUB_SUB_EVENTS.contentAdded, function (data) {
    // Register triggers for new content
    const triggers = data.content.querySelectorAll(
      "[data-event='toggle-cart']"
    );
    triggers.forEach(registerTrigger);

    // Register add to cart buttons for new content
    const addCartButtons = data.content.querySelectorAll(
      "[data-event='add-to-cart']"
    );
    addCartButtons.forEach(registerAddCartButton);

    // Register cart item controls for new content
    const cartItemQuantity = data.content.querySelectorAll(
      ".Cart_Item .Quantity_Selector_Inputs input"
    );
    const cartItemRemove = data.content.querySelectorAll(
      "[data-event='remove-cart-item']"
    );
    cartItemQuantity.forEach(registerControls);
    cartItemRemove.forEach(registerRemove);
  });
});

const cartDrawer = document.querySelector(".Cart_Drawer");

//get header height
const header = document.querySelector("header");
// body.style.setProperty("--header-height", `${header.offsetHeight}px`);

subscribe(PUB_SUB_EVENTS.closeOpenPopup, function (data) {
  if (data.source !== cartDrawer) {
    cartDrawer.classList.remove("Open");
  }
});

subscribe(PUB_SUB_EVENTS.cartToggle, function (data) {
  if (
    !data.source.matches(".Close_Cart_Drawer") &&
    document.querySelector("#Cart_Drawer.Open")
  ) {
    return;
  }
  publish(PUB_SUB_EVENTS.closeOpenPopup, { source: cartDrawer });
  cartDrawer.classList.toggle("Open");
});

subscribe(PUB_SUB_EVENTS.cartUpdate, async function (data) {
  const updatedCart = await getCartSection();
  const section = updatedCart[CART_DRAWER_ID];
  const html = new DOMParser().parseFromString(section, "text/html");

  const newContent = html.querySelector(".Cart_Drawer_Content");
  const newPrice = html.querySelector(".Checkout_Button .Price");

  updateCart(newContent, newPrice);
});

const cartNotif = document.querySelector(".Cart_Button .Notification");

function updateCart(newContent, newPrice) {
  const cartItems = cartDrawer.querySelector(".Cart_Items");
  const newItems = newContent.querySelector(".Cart_Items");
  if (cartItems && newContent.querySelector(".Cart_Items")) {
    cartItems.replaceWith(newItems);
    publish(PUB_SUB_EVENTS.contentAdded, { content: newItems });
  } else {
    cartDrawer.querySelector(".Cart_Drawer_Content").replaceWith(newContent);
    publish(PUB_SUB_EVENTS.contentAdded, { content: newContent });
  }

  // cartNotif.classList.remove("Open");

  if (cartNotif && cartDrawer.querySelectorAll(".Cart_Item").length > 0) {
    cartNotif.classList.add("Open");
  }

  // Change price
  const price = cartDrawer.querySelector(".Checkout_Button .Price");
  if (price) price.textContent = newPrice.textContent;
}

const CART_DRAWER_ID = "cart-drawer";

async function getCartSection() {
  return await fetch(`/?sections=${CART_DRAWER_ID}`, {
    method: "GET",
  })
    .then((res) => {
      return res.json();
    })
    .catch((e) => {
      console.error("Error:", e);
    });
}

async function getCart() {
  return await fetch("/cart.js", {
    method: "GET",
  })
    .then((res) => {
      return res.json();
    })
    .catch((e) => {
      console.error("Error:", e);
    });
}

async function serverConfirmation(key, value) {
  const res = await fetch(`/cart/change?id=${key}&quantity=${value}`)
    .then((response) => {
      return response;
    })
    .catch((e) => console.error("Error:", e));
  return res.status == 200;
}
